// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4451) return "static/chunks/4451-318a949e12046a0f.js";
	if (chunkId === 2505) return "static/chunks/2505-cfd37add6c29afe7.js";
	if (chunkId === 5111) return "static/chunks/5111-8dcaf0885cbb4e90.js";
	if (chunkId === 4938) return "static/chunks/4938-7db77d5dec80e3a6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2435":"06cb0c69fdb35323","4514":"40448af508ecedcd","5746":"5e7260d32319e4ae","8803":"fd44cdf5ad8fccfc"}[chunkId] + ".js";
};